<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {}
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        /////////////////////////////////////////////////////
        // Mounted
        /////////////////////////////////////////////////////
        mounted() {
            if (window.innerHeight < 900) {
                $('.nav-menu').animate({scrollTop: 200}, 'slow')
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextPage() {
                if (this.step == 1) {
                    window.location = '18.html'
                }
            },
            nextStep() {
                this.$emit('next', parseInt(this.step) + 1);
            },
            prevStep() {
                this.$emit('prev', parseInt(this.step) - 1);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-17.vue